import React from 'react';

import './HeaderLogos.css';

import logoHUDigital from '../../assets/logo/logoHUDigital.svg';
import logoAGHUX from '../../assets/logo/logoAghux.svg';

function HeaderLogos() {
  return (
    <div className="header">
      <img
        className="logoHU-header"
        alt="logo hudigital"
        src={logoHUDigital}
      />
      <img alt="logo aguhx" src={logoAGHUX} className="logoAGHUeader" />
    </div>
  );
}

export default HeaderLogos;
